module.exports = __webpack_public_path__ + "img/logo.fa63f840.png";